import React from 'react';
import { useIntl } from 'react-intl';
import { Col, Container, Row } from 'reactstrap';
import { nextAsset } from '../../../../components/nextAsset';

export const FeaturesNotAll: React.FC = () => {
  const intl = useIntl();

  return (
    <div className="smartlinks-music-marketing py-5">
      <Container className="pt-5">
        <Row>
          <Col className="">
            <Container className="audience-container">
              <h2 className="main-header text-center pt-5 pb-3">
                {intl.formatMessage({
                  id: 'sml.web.smartlinks.notall',
                  defaultMessage: 'That’s not all'
                })}
              </h2>
              <p className="main-header-subtitle text-center pb-3">
                {intl.formatMessage({
                  id: 'sml.web.smartlinks.notall.description',
                  defaultMessage: 'More tools to help you build better relationships with your fans.'
                })}
              </p>
              <Row className="audience">
                <Col xs={12} md={7}>
                  <img
                    src={nextAsset('images/smartLinks/home/music-player.png')}
                    className="img-fluid"
                    alt="Music player"
                  />
                </Col>

                <Col xs={12} md={5} className="d-flex align-items-center">
                  <p className="header-subtitle text-body">
                    {intl.formatMessage(
                      {
                        id: 'sml.web.smartlinks.notall.player',
                        defaultMessage: '<b>Music player</b> to preview your tracks'
                      },
                      {
                        b: (str: React.ReactNode[]) => <strong>{str}</strong>
                      }
                    )}
                  </p>
                </Col>
              </Row>
              <Row className="audience">
                <Col xs={12} md={7} className="d-flex align-items-center justify-content-center">
                  <Row>
                    <Col>
                      <img
                        src={nextAsset('images/smartLinks/features/presave.png')}
                        className="img-fluid"
                        alt="Pre-save"
                      />
                    </Col>
                  </Row>
                </Col>

                <Col xs={12} md={5} className="d-flex align-items-center justify-content-center">
                  <p className="header-subtitle text-body">
                    {intl.formatMessage(
                      {
                        id: 'sml.web.smartlinks.notall.preave',
                        defaultMessage: '<b>Pre-save</b> to build the hype for new releases'
                      },
                      {
                        b: (str: React.ReactNode[]) => <strong>{str}</strong>
                      }
                    )}
                  </p>
                </Col>
              </Row>
              <Row className="audience p-4">
                <Col xs={12} md={7} className="d-flex align-items-center">
                  <div className="d-flex overflow-hidden">
                    <img
                      src={nextAsset('images/smartLinks/features/accounts.png')}
                      className="img-fluid"
                      alt="Account example"
                    />
                  </div>
                </Col>

                <Col xs={12} md={5} className="d-flex align-items-center justify-content-center">
                  <p className="header-subtitle text-body">
                    {intl.formatMessage(
                      {
                        id: 'sml.web.smartlinks.notall.accounts',
                        defaultMessage: '<b>Multiple accounts</b> (perfect for managers and music labels!)'
                      },
                      {
                        b: (str: React.ReactNode[]) => <strong>{str}</strong>
                      }
                    )}
                  </p>
                </Col>
              </Row>
              <Row className="audience p-4">
                <Col xs={12} md={7} className="d-flex align-items-center">
                  <img
                    src={nextAsset('images/smartLinks/features/custom-domains.png')}
                    className="img-fluid"
                    alt="Custom domains"
                  />
                </Col>

                <Col xs={12} md={5} className="d-flex align-items-center justify-content-center">
                  <p className="header-subtitle text-body">
                    {intl.formatMessage(
                      {
                        id: 'sml.web.smartlinks.notall.domains',
                        defaultMessage: '<b>Custom domains and sub-domains</b> for branded links'
                      },
                      {
                        b: (str: React.ReactNode[]) => <strong>{str}</strong>
                      }
                    )}
                  </p>
                </Col>
              </Row>
              <Row className="audience p-4">
                <Col xs={12} md={7} className="d-flex align-items-center">
                  <img
                    src={nextAsset('images/smartLinks/features/retargeting.png')}
                    className="img-fluid"
                    alt="Retargeting"
                  />
                </Col>

                <Col xs={12} md={5} className="d-flex align-items-center justify-content-center">
                  <p className="header-subtitle text-body">
                    {intl.formatMessage(
                      {
                        id: 'sml.web.smartlinks.notall.pixel',
                        defaultMessage: '<b>Retargeting pixel</b> to convert traffic into fans'
                      },
                      {
                        b: (str: React.ReactNode[]) => <strong>{str}</strong>
                      }
                    )}
                  </p>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
